import { render, staticRenderFns } from "./OrgCafeReports.vue?vue&type=template&id=674409d8&"
import script from "./OrgCafeReports.vue?vue&type=script&lang=js&"
export * from "./OrgCafeReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports